export const featureFlags = {
  enablePPV: process.env.VUE_APP_ENABLE_PPV === 'true',
}

const FeatureFlagsPlugin = {
  install(Vue) {
    Vue.prototype.$featureFlags = featureFlags
  },
}

export default FeatureFlagsPlugin
